import { SelectOption, Select } from 'components/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { getProjects } from 'store/selectors/projects';

const ProjectSelector = ({ selectedProject, onChangeProject }) => {
  const projects = useSelector(getProjects);

  return (
    <Select
      className="select-template__btn"
      name="projectId"
      showSearch
      value={selectedProject}
      onChange={onChangeProject}
    >
      <SelectOption key="default" value="">
        Select Project To Assign
      </SelectOption>
      {projects.map(p => (
        <SelectOption key={p.id} value={p.id}>
          {p.name}
        </SelectOption>
      ))}
    </Select>
  );
};

export default ProjectSelector;
